import { PersonBenefits } from '@esportal/portal-service';
import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { PortalContext } from '../../context/portal-context';
import { COLOR_TOKEN } from '../../helpers/color-tokens';
import { HuchaContainer } from './hucha/hucha-container';
import { Vouchers } from './vouchers/vouchers';

const Background = styled.div`
	background: ${COLOR_TOKEN.background.highlight};
`;

export const Benefits: React.FC<{
	personBenefits: PersonBenefits;
}> = ({ personBenefits }) => {
	const { portalService } = React.useContext(PortalContext);
	const userData = portalService?.getPerson()?.getValue();
	const vouchersRef = React.useRef<HTMLDivElement | null>(null);

	return (
		<Background>
			<section>
				<Container
					data-testid="benefits-container"
					padding={{
						top: {
							[Breakpoints.default]: ContainerPadding.dynamic0250,
							[Breakpoints.b560]: ContainerPadding.dynamic0150,
						},
						bottom: {
							[Breakpoints.default]: ContainerPadding.dynamic0300,
							[Breakpoints.b560]: ContainerPadding.dynamic0250,
						},
					}}
					wrap="always"
					gutter={ContainerGutter.dynamic0100}
				>
					<Layout
						data-testid="benefits-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'benefits-section', columns: 22 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						<Container data-testid="benefits-container" gutter={ContainerGutter.dynamic0100} wrap="always">
							<Container data-testid="top-text" wrap={'always'}>
								<Text
									appearance={TokenTextAppearance.bigcopy200}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
									bold
								>
									Beneficios
								</Text>
								<Text
									appearance={TokenTextAppearance.headline500}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
								>
									Para ti, por <b>ser del club</b>
								</Text>
							</Container>
						</Container>
					</Layout>

					<Layout
						data-testid="vouchers-layout"
						appearance={{
							[Breakpoints.default]: [{ name: 'vouchers-section', columns: 24 }],
						}}
					>
						<Vouchers userData={userData} personBenefits={personBenefits} vouchersRef={vouchersRef} />
					</Layout>

					<Layout
						data-testid="hucha-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'hucha-section', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 3 },
								{ name: 'hucha-section', columns: 18 },
								{ name: '.', columns: 3 },
							],
						}}
					>
						<Container data-testid="hucha-container" gutter={ContainerGutter.dynamic0100} wrap="always">
							<Text
								appearance={TokenTextAppearance.headline400}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
							>
								<b>Ahorro acumulado</b> para tu próximo Volkswagen
							</Text>
							<HuchaContainer userData={userData} personBenefits={personBenefits} />
						</Container>
					</Layout>
				</Container>
			</section>
		</Background>
	);
};
